import React from 'react'
import CardScanner from '../CardScanner'

const CardScannerPage = () => {
  return (
    <div>
      <CardScanner/>
    </div>
  )
}

export default CardScannerPage
